import React, { useState } from 'react';
import ResultsView from '../components/public/ResultsView';
import { LEVEL_OPTIONS, FRANJA_OPTIONS, APPARATUS_OPTIONS } from '../utils/constants';

const PublicView = ({ events, selectedEvent, setSelectedEvent, currentEvent, currentClubs }) => {
  const [publicFilters, setPublicFilters] = useState({
    level: '',
    franja: '',
    club: '',
    apparatus: ''
  });
  const [showFilters, setShowFilters] = useState(true);

  const getUniqueClubs = () => {
    const clubsSet = new Set();
    (Array.isArray(currentClubs) ? currentClubs : []).forEach(club => clubsSet.add(club.name));
    return Array.from(clubsSet);
  };

  const resetFilters = () => {
    setPublicFilters({
      level: '',
      franja: '',
      club: '',
      apparatus: ''
    });
  };

  const getGymnastsByCategory = (level, franja) => {
    const allGymnasts = (Array.isArray(currentClubs) ? currentClubs : []).flatMap(club => 
      club.gymnasts.map(g => ({
        ...g,
        clubName: club.name,
        clubImage: club.image_url
      }))
    );
    
    return allGymnasts
      .filter(g => {
        // Filtrar por la categoría específica (nivel y franja)
        const categoryLevelMatch = g.level === level;
        const categoryFranjaMatch = g.franja === franja;
        
        // Aplicar filtros adicionales del usuario
        const levelMatch = !publicFilters.level || g.level === publicFilters.level;
        const franjaMatch = !publicFilters.franja || g.franja === publicFilters.franja;
        const clubMatch = !publicFilters.club || g.clubName === publicFilters.club;
        
        return categoryLevelMatch && categoryFranjaMatch && levelMatch && franjaMatch && clubMatch;
      })
      .sort((a, b) => {
        if (publicFilters.apparatus && publicFilters.apparatus !== 'Todos') {
          const scoreA = a.scores[publicFilters.apparatus] || 0;
          const scoreB = b.scores[publicFilters.apparatus] || 0;
          return scoreB - scoreA;
        }
        return b.allRound - a.allRound;
      });
  };

  return (
    <ResultsView
      events={events}
      selectedEvent={selectedEvent}
      setSelectedEvent={setSelectedEvent}
      currentEvent={currentEvent}
      currentClubs={currentClubs}
      publicFilters={publicFilters}
      setPublicFilters={setPublicFilters}
      showFilters={showFilters}
      setShowFilters={setShowFilters}
      getUniqueClubs={getUniqueClubs}
      resetFilters={resetFilters}
      getGymnastsByCategory={getGymnastsByCategory}
      LEVEL_OPTIONS={LEVEL_OPTIONS}
      FRANJA_OPTIONS={FRANJA_OPTIONS}
      APPARATUS_OPTIONS={APPARATUS_OPTIONS}
    />
  );
};

export default PublicView;